import React from 'react';

import { Grid } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    '@media (min-width: 1024px)': {
      width: '1024px',
    },
  },
});

export default function PageItemContainer(props) {
  const classes = useStyles();
  const { children } = props;

  return (
    <Grid
      item
      style={{
        maxWidth: '1024px',
      }}
      className={classes.root}
    >
      {children}
    </Grid>
  );
}
